<div class="offer" *ngIf="openedDocument$ | async as openedDocument" >
    <icc-sales-document-summary
        [openedDocument]="openedDocument"
        [salesDocument]="salesDocument$ | async"
        [buyDocuments]="buyDocuments$ | async"
        [positions]="positions$ | async"
        [allPositions]="allPositions$ | async"
        [buyPositions]="buyPositions$ | async"
        [allBuyPositions]="allBuyPositions$ | async"
        [buyPositionsPerDocument]="buyPositionsPerDocument$ | async"
        [buyPositionsMap]="buyPositionsMap$ | async"
        [allBuyPositionsMap]="allBuyPositionsMap$ | async"
        [connectedBuyPositions]="connectedBuyPositions$ | async"
        [currency]="openedDocument.priceCurrency"
        [groupingSchemaId]="groupingControl.value"
        [summingGroupingSchemaId]="summingControl.value"
        [sortingMode]="sortingControl.value"
        (modeChanged)="mode = $event; onModeChange(mode)"
        (activeBuyDocumentChanged)="onActiveBuyDocumentChange($event)"
    ></icc-sales-document-summary>
    <div *ngIf="showGroupEditOptions" class="group-edit-options">
        <ng-container *ngFor="let option of groupEditOptions">
            <button iccButton appearance="outline" *ngIf="option.show()" (click)="option.callback()">
                {{ option.title }}
            </button>
        </ng-container>
    </div>
    <div class="document-grouping-options" *ngIf="openedDocument?.salesDocumentTypeId !== 5">

        <div>

            <label iccLabel for="grouping">
                {{ 'SALES_DOCUMENT|Grupowanie wg:' | translate }}
            </label>

            <icc-select
                size="small"
                name="grouping"
                [formControl]="groupingControl"
            >
                <option
                    *ngFor="let grouping of openedDocument.groups"
                    [value]="grouping.groupSchemaId"
                >
                    {{ groupingSchemas[grouping.groupSchemaId]?.name | translate }}
                </option>

            </icc-select>

        </div>
        <div *ngIf="mode !== 'purchase' || canViewBuyPrices">

            <label iccLabel for="summing">
                {{ 'SALES_DOCUMENT|Podsumowanie cenowe wg:' | translate }}
            </label>

            <icc-select
                size="small"
                name="summing"
                [formControl]="summingControl"
            >

                <option
                    *ngFor="let grouping of openedDocument.groups"
                    [value]="grouping.groupSchemaId"
                >
                    {{ groupingSchemas[grouping.groupSchemaId]?.name | translate }}
                </option>

            </icc-select>

        </div>
        <div>

            <label iccLabel for="sorting">
                {{ 'SALES_DOCUMENT|Sortowanie wg:' | translate }}
            </label>

            <icc-select
                size="small"
                id="sorting"
                name="sorting"
                [formControl]="sortingControl"
            >
                <option value="created" translate>SALES_DOCUMENT|kolejności dodania rosnąco</option>
                <option value="createdDesc" translate>SALES_DOCUMENT|kolejności dodania malejąco</option>
                <option value="name" translate>SALES_DOCUMENT|nazw własnych rosnąco</option>
                <option value="nameDesc" translate>SALES_DOCUMENT|nazw własnych malejąco</option>
                <option value="custom" translate>SALES_DOCUMENT|użytkownika</option>

            </icc-select>

            <div *ngIf="sortingControl.value === 'custom' && canPositionsBeEdited && mode === 'sale'" class="document-sorting-actions">

                <button
                    iccButton
                    (click)="sorting = !sorting"
                    appearance="secondary"
                    *ngIf="!sorting"
                >
                    {{ 'SALES_DOCUMENT|Ustaw kolejność' | translate }}
                </button>

                <button
                    iccButton
                    (click)="sorting = !sorting"
                    appearance="secondary"
                    *ngIf="sorting"
                >
                    {{ 'SALES_DOCUMENT|Zakończ zmianę kolejności' | translate }}
                </button>

            </div>

        </div>

    </div>
    <div class="product-elements" *ngIf="groups$ | async as groups" >
        <div *ngFor="let group of groups; index as groupNo; trackBy: trackByGroup" cdkDropList [cdkDropListDisabled]="!sorting" (cdkDropListDropped)="changeOrder(group, $event)">
            <ng-container *ngIf="group.positions.length > 0" >
                <h2>{{ group.name | translate }}</h2>
                <ng-container  *ngFor="let position of group.positions; index as id; trackBy: trackByPosition">
                    <icc-sales-document-position
                        class="details-card"
                        *ngIf="position != null && (mode !== 'comparison' || buyPositionsMap.has(position.uuid)) && openedDocuments[position.documentId]"
                        [position]="position"
                        [salesPosition]="salesPositionsMap.get(position.uuid)"
                        [buyPosition]="buyPositionsMap.get(position.uuid) || mode === 'purchase' && position"
                        [positionTree]="positionsDetails.get(position.uuid)"
                        [showDetails]="positionsShowDetails.get(position.uuid)"
                        [positionTitle]="positionsTitles.get(position.uuid)"
                        [positionsIndexes]="positionsIndexes"
                        [positionsTitles]="positionsTitles"
                        [index]="id"
                        [sorting]="sorting"
                        [document]="openedDocuments[position.documentId]"
                        [openedDocument]="openedDocument"
                        [attachments]="(attachments$ | async)?.get(position.uuid) || []"
                        [currency]="openedDocument.priceCurrency"
                        cdkDrag
                        [cdkDragDisabled]="!sorting"
                        [viewMode]="mode"
                        (showDetailsEvent)="switchShowDetails(position.uuid, $event)"
                        [id]="position.uuid"
                        [synced]="synced"
                        [missingBuyDocument]="missingBuyDocument"
                    ></icc-sales-document-position>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <div class="document-grouping-options">

    </div>

    <div class="position-description" *ngIf="openedDocument?.salesDocumentTypeId !== 2 && openedDocument?.salesDocumentTypeId !== 5">


        <span class="title">{{ 'INTERFACE|Opis' | translate }}</span>

        <div class="icc-card">

            <icc-inplace *ngIf="!openedDocument.isConfirmed" >
                <ng-template iccTemplate="display">
                    <span *ngIf="openedDocument.description" class="document-description">{{openedDocument.description}}</span>
                    <span *ngIf="!openedDocument.description">{{ 'INTERFACE|Kliknij, aby ustawić opis' | translate }}</span>
                </ng-template>
                <ng-template iccTemplate="content">
                    <textarea [ngModel]="openedDocument.description" (ngModelChange)="changeDescription($event)" name="document-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus></textarea>
                </ng-template>
            </icc-inplace>

            <p  class="document-description" *ngIf="openedDocument.isConfirmed">
                {{openedDocument.description}}
            </p>


        </div>

    </div>

    <div class="position-description" *ngIf="getBuyProducerDocument() && canBuyProducerNotesRead">
        <span class="title">{{ 'INTERFACE|Uwagi produkcyjne (Zakup)' | translate }}</span>
        <div class="icc-card">
            <icc-inplace *ngIf="canBuyProducerNotesBeEdited" >
                <ng-template iccTemplate="display">
                    <span *ngIf="getBuyProducerDocument()?.producerNotes" class="document-description">{{getBuyProducerDocument()?.producerNotes}}</span>
                    <span *ngIf="!getBuyProducerDocument()?.producerNotes">{{ 'SALES_DOCUMENT|Kliknij, aby ustawić uwagi' | translate }}</span>
                </ng-template>
                <ng-template iccTemplate="content">
                    <textarea [ngModel]="getBuyProducerDocument()?.producerNotes" (ngModelChange)="changeProducerNotes($event, getBuyProducerDocument())" name="document-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus maxlength="500"></textarea>
                </ng-template>
            </icc-inplace>

            <p class="document-description" *ngIf="!canBuyProducerNotesBeEdited && getBuyProducerDocument()?.producerNotes">
                {{getBuyProducerDocument()?.producerNotes}}
            </p>
        </div>
    </div>
    <div class="position-description" *ngIf="canSalesProducerNotesRead">
        <span class="title">{{ 'INTERFACE|Uwagi produkcyjne (Sprzedaż)' | translate }}</span>
        <div class="icc-card">
            <icc-inplace *ngIf="canSalesProducerNotesBeEdited" >
                <ng-template iccTemplate="display">
                    <span *ngIf="openedDocument?.producerNotes" class="document-description">{{openedDocument?.producerNotes}}</span>
                    <span *ngIf="!openedDocument?.producerNotes">{{ 'SALES_DOCUMENT|Kliknij, aby ustawić uwagi' | translate }}</span>
                </ng-template>
                <ng-template iccTemplate="content">
                    <textarea [ngModel]="openedDocument?.producerNotes" (ngModelChange)="changeProducerNotes($event, openedDocument)" name="document-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus maxlength="500"></textarea>
                </ng-template>
            </icc-inplace>

            <p class="document-description" *ngIf="!canSalesProducerNotesBeEdited && openedDocument?.producerNotes">
                {{openedDocument?.producerNotes}}
            </p>
        </div>
    </div>

    <div class="position-description" *ngIf="(activeBuyDocument || buyDocuments.length === 1) && canRequestComplaintV1 && mode === 'purchase' && openedDocument?.salesDocumentTypeId === 3">
        <span class="title">{{ 'INTERFACE|Reklamacja na całe zamówienie' | translate }}</span>

        <div class="icc-card">
             <button
                class="single-button"
                iccButton
                [appearance]="requestComplaintAction.appearance"
                *ngIf="requestComplaintAction.show()"
                (click)="requestComplaintAction.action()"
                [disabled]="requestComplaintAction.disabled()"
                [attr.data-test]="requestComplaintAction.testId"
            >
                <icc-icon [name]="requestComplaintAction.icon"></icc-icon>
                {{ requestComplaintAction.label | translate }}
            </button>
        </div>
    </div>

    <icc-sales-document-attachments
        *ngIf="openedDocument?.salesDocumentTypeId !== 2 && openedDocument?.salesDocumentTypeId !== 5"
        [salesDocumentUuid] = "openedDocument.uuid"
        [attachments] = "(attachments$ | async)?.get(openedDocument.uuid) || []"
        [isConfirmed] = "openedDocument.isConfirmed"
    ></icc-sales-document-attachments>

    <div class="document-deliveries" *ngIf="(deliveries$ | async)?.length">
        <span class="title">{{ 'SALES_DOCUMENT|Wysyłka' | translate }}</span>
        <div class="deliveries-list">
            <div *ngFor="let delivery of (deliveries$ | async)" class="document-delivery">
                <div class="document-delivery-header">
                    <ng-container *ngIf="getDeliveryDriver(delivery) as driver">
                        <b>{{ driver.name }}</b>
                        <span>{{ driver.phoneNumber }}</span>
                    </ng-container>
                    <icc-chip iccChipSmall iccChipStatus [color]="getDeliveryStatusColor(delivery)" [focusable]="false">
                        <icc-icon name="state"></icc-icon>
                        {{ getDeliveryStatusLabel(delivery) || ('INTERFACE|Niezdefiniowany' | translate) }}
                    </icc-chip>
                    <button iccButton appearance="outline" (click)="openDeliverySignaturePreview(delivery)" *ngIf="delivery.isConfirmed">
                        {{ 'DELIVERY|Podgląd podpisu' | translate }}
                    </button>
                </div>
                <div class="document-delivery-content" *ngIf="groups$ | async as groups">
                    <ng-container *ngFor="let group of groups; trackBy: trackByGroup">
                        <ng-container *ngIf="group.positions.length > 0" >
                            <ng-container  *ngFor="let position of group.positions; index as id; trackBy: trackByPosition">
                                <p *ngIf="delivery.positions[position.uuid] as deliveryPositionStatus">
                                    {{ positionsIndexes.get(position.uuid)}}. {{ positionsTitles.get(position.uuid)?.join('') }} <ng-container *ngIf="delivery.isConfirmed">
                                        <icc-chip iccChipSmall iccChipStatus [color]="getPositionDeliveryStatusColor('delivered')" [focusable]="false" *ngIf="deliveryPositionStatus === 'delivered'">
                                            <icc-icon name="state"></icc-icon>
                                            {{ getPositionDeliveryStatusLabel('delivered') || ('INTERFACE|Niezdefiniowany' | translate) }}
                                        </icc-chip>
                                        <icc-chip iccChipSmall iccChipStatus [color]="getPositionDeliveryStatusColor('not-delivered')" [focusable]="false"  *ngIf="deliveryPositionStatus !== 'delivered'">
                                            <icc-icon name="state"></icc-icon>
                                            {{ getPositionDeliveryStatusLabel('not-delivered') || ('INTERFACE|Niezdefiniowany' | translate) }}
                                        </icc-chip>
                                    </ng-container>
                                </p>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <h6 *ngIf="delivery.driverNote">{{ 'DELIVERY|Notatka kierowcy' | translate}}</h6>
                    <div *ngIf="delivery.driverNote" class="document-description">
                        {{ delivery.driverNote }}
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>
